import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.06077 8.00011L14.0608 3.00011L13.0001 1.93945L8.00011 6.93945L3.00011 1.93945L1.93945 3.00011L6.93945 8.00011L1.93945 13.0001L3.00011 14.0608L8.00011 9.06077L13.0001 14.0608L14.0608 13.0001L9.06077 8.00011Z"
	})
});
export default SvgClose;
